import { render, staticRenderFns } from "./classPay.vue?vue&type=template&id=5ce7c00c&scoped=true"
import script from "./classPay.vue?vue&type=script&lang=js"
export * from "./classPay.vue?vue&type=script&lang=js"
import style0 from "./classPay.vue?vue&type=style&index=0&id=5ce7c00c&prod&scoped=true&lang=css"
import style1 from "./classPay.vue?vue&type=style&index=1&id=5ce7c00c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce7c00c",
  null
  
)

export default component.exports